/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material

import ActionButtons from 'material/expandablesection/actionbuttons';
// styles
import injectSheet from 'react-jss';
import styles from 'material/expandablesection/expandablesection_styles';


const ExpandableSection = (props) => {

  const {
      controller,
      handleCancel,
      handleSave,
      disableSave,
      isOpened,
      setIsOpened,
      processing
  } = props;


  const openedClass = isOpened ? 'opened' : ''
  return(
    <div className={`expandablesection ${props.classes.expandablesection} ${props.className}`}>
        {controller}
        <div className={`collapsable ${openedClass}`}>
          <div className='innerWrap'>
            {props.children}
          </div>
        </div>

        {(isOpened) &&
        <div className='footer controls'>
            <ActionButtons handleSave={handleSave} disableSave={disableSave} isOpened={isOpened} setIsOpened={setIsOpened} handleCancel={handleCancel} processing={processing} />
        </div>}
    </div>
  )
};

export default injectSheet(styles)(ExpandableSection)
